export const SearchScroll = 'point';

export const SearchEventType = 'SearchEventType';
